import { RouteConfig } from 'vue-router';

import { Rules as CaslRules } from '../../../back/src/casl/casl.constants';

import AmostrasIndexLaboratorioGuarulhos from '@/pages/amostras/AmostrasIndexLaboratorioGuarulhos.vue';
import AmostrasIndexLaboratorio from '@/pages/amostras/AmostrasIndexLaboratorio.vue';
import LayoutLaboratorioMatrizCatalisadores from '@/layouts/LayoutLaboratorioMatrizCatalisadores.vue';
import LayoutLaboratorioMatrizGeral from '@/layouts/LayoutLaboratorioMatrizGeral.vue';
import AmostrasCatalisadoresLaboratorioMatrizColeta from '@/pages/amostras/AmostrasCatalisadoresLaboratorioMatrizColeta.vue';
import AmostrasCatalisadoresLaboratorioMatrizAtivas from '@/pages/amostras/AmostrasCatalisadoresLaboratorioMatrizAtivas.vue';
import AmostrasCatalisadoresLaboratorioMatrizFinalizadas from '@/pages/amostras/AmostrasCatalisadoresLaboratorioMatrizFinalizadas.vue';
// import AmostrasGeralLaboratorioMatriz from '@/pages/amostras/AmostrasGeralLaboratorioMatriz.vue';
import AmostrasGeralLaboratorioMatrizRecebimento from '@/pages/amostras/AmostrasGeralLaboratorioMatrizRecebimento.vue';
import AmostrasGeralLaboratorioMatrizAtivas from '@/pages/amostras/AmostrasGeralLaboratorioMatrizAtivas.vue';
import AmostrasGeralLaboratorioMatrizFinalizadas from '@/pages/amostras/AmostrasGeralLaboratorioMatrizFinalizadas.vue';
import AmostrasEnsaios from '@/pages/amostras/AmostrasEnsaios.vue';
import AmostrasEnsaiosFireAssay from '@/pages/amostras/AmostrasEnsaiosFireAssay.vue';
import AmostrasIcpUpload from '@/pages/amostras/AmostrasIcpUpload.vue';

import AmostrasVer from '@/pages/amostras/AmostrasVer.vue';
import AmostrasLaudo from '@/pages/amostras/AmostrasLaudo.vue';

const routes: RouteConfig[] = [
  {
    path: '/amostras/laboratorio_guarulhos',
    name: 'AmostrasIndexLaboratorioGuarulhos',
    component: AmostrasIndexLaboratorioGuarulhos,
    meta: {
      icon: 'mdi-flask-outline',
      rules: [CaslRules.Amostra.listarLaboratorioGuarulhos],
    },
  },
  {
    path: '/amostras/laboratorio',
    name: 'AmostrasIndexLaboratorio',
    component: AmostrasIndexLaboratorio,
    meta: {
      icon: 'mdi-flask',
      layout: 'LaboratorioMatriz',
      rules: [CaslRules.Amostra.listarLaboratorio],
    },
  },
  {
    path: '/amostras/laboratorio/catalisadores',
    component: LayoutLaboratorioMatrizCatalisadores,
    children: [
      {
        path: '/amostras/laboratorio/catalisadores/coleta',
        name: 'AmostrasCatalisadoresLaboratorioMatrizColeta',
        component: AmostrasCatalisadoresLaboratorioMatrizColeta,
        meta: {
          icon: 'mdi-car-back',
          title: 'Matriz - Catalisadores',
          layout: 'LaboratorioMatriz',
          rules: [CaslRules.Amostra.listarLaboratorioCatalisadoresAtivas],
        },
      },
      {
        path: '/amostras/laboratorio/catalisadores/ativas',
        name: 'AmostrasCatalisadoresLaboratorioMatrizAtivas',
        component: AmostrasCatalisadoresLaboratorioMatrizAtivas,
        meta: {
          icon: 'mdi-car-back',
          title: 'Matriz - Catalisadores',
          layout: 'LaboratorioMatriz',
          rules: [CaslRules.Amostra.listarLaboratorioCatalisadoresAtivas],
        },
      },
      {
        path: '/amostras/laboratorio/catalisadores/finalizadas',
        name: 'AmostrasCatalisadoresLaboratorioMatrizFinalizadas',
        component: AmostrasCatalisadoresLaboratorioMatrizFinalizadas,
        meta: {
          icon: 'mdi-car-back',
          title: 'Matriz - Catalisadores',
          layout: 'LaboratorioMatriz',
          rules: [CaslRules.Amostra.listarAmostrasFinalizadas],
        },
      },
    ],
    meta: {
      icon: 'mdi-car-back',
      layout: 'LaboratorioMatriz',
      rules: [CaslRules.Amostra.listarLaboratorio],
    },
  },
  {
    path: '/amostras/laboratorio/geral',
    component: LayoutLaboratorioMatrizGeral,
    children: [
      {
        path: '/amostras/laboratorio/geral/recebimento',
        name: 'AmostrasGeralLaboratorioMatrizRecebimento',
        component: AmostrasGeralLaboratorioMatrizRecebimento,
        meta: {
          icon: 'mdi-chip',
          title: 'Matriz - Geral',
          layout: 'LaboratorioMatriz',
          rules: [CaslRules.Amostra.listarLaboratorio],
        },
      },
      {
        path: '/amostras/laboratorio/geral/ativas',
        name: 'AmostrasGeralLaboratorioMatrizAtivas',
        component: AmostrasGeralLaboratorioMatrizAtivas,
        meta: {
          icon: 'mdi-chip',
          title: 'Matriz - Geral',
          layout: 'LaboratorioMatriz',
          rules: [CaslRules.Amostra.listarLaboratorio],
        },
      },
      {
        path: '/amostras/laboratorio/geral/finalizadas',
        name: 'AmostrasGeralLaboratorioMatrizFinalizadas',
        component: AmostrasGeralLaboratorioMatrizFinalizadas,
        meta: {
          icon: 'mdi-chip',
          title: 'Matriz - Geral',
          layout: 'LaboratorioMatriz',
          rules: [CaslRules.Amostra.listarLaboratorio],
        },
      },
    ],
  },
  {
    path: '/amostras/laboratorio/fire_assay',
    name: 'AmostrasEnsaiosFireAssay',
    component: AmostrasEnsaiosFireAssay,
    meta: {
      icon: 'mdi-fire',
      title: 'Matriz - Fire Assay',
      layout: 'LaboratorioMatriz',
      // rules: [CaslRules.Amostra.listarLaboratorio],
    },
  },
  {
    path: '/amostras/laboratorio/:ensaioMetodoTipo',
    name: 'AmostrasEnsaios',
    component: AmostrasEnsaios,
    meta: {
      icon: 'mdi-flask',
      layout: 'LaboratorioMatriz',
      rules: [CaslRules.Amostra.listarLaboratorio],
    },
  },
  {
    path: '/amostras/icp',
    name: 'AmostrasIcpUpload',
    component: AmostrasIcpUpload,
    meta: {
      icon: 'mdi-flask-outline',
    },
  },
  {
    path: '/amostras/:amostraId',
    name: 'AmostrasVer',
    component: AmostrasVer,
    meta: {
      icon: 'mdi-flask-outline',
      rules: [CaslRules.Amostra.buscar],
    },
  },
  {
    path: '/amostras/:amostraId/laudo',
    name: 'AmostrasLaudo',
    component: AmostrasLaudo,
    meta: {
      icon: 'mdi-flask-outline',
      // rules: [CaslRules.Amostra.listarLaboratorioGuarulhos],
    },
  },
];

export default routes;
